/**
 * A Stimulus controller that disables target elements
 *
 * @module DisableController
 */

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['element'];

  static values = {
    timeout: { type: Number, default: 3000 }
  };

  toggle() {
    this.elementTargets.forEach((target) => {
      target.disabled = !target.disabled;
    });
  }

  toggleWithTimeout() {
    this.toggle();

    setTimeout(() => {
      this.toggle();
    }, this.timeoutValue);
  }
}
